import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import * as modal from "../../util/modal.ts";
import ApiServer from "../../ApiServer.ts";
import {recipeCategoriesSyncCache} from "../../mealplanner/mealplannerApi.ts";

import * as FwDatas from "../../FwDatas.ts";
import {SafeString} from "../../handlebars_family.ts";
import MAIN_MODAL from "../../mealplanner/modal_recipecategories.mustache";
import TPL_ITEM from "../../mealplanner/modal_recipecategories_item.mustache";

import Icons from "../../svg/Icons.ts"
import { registerDragStart } from "../../lib/FileUtils.ts";
import { CategoryBean } from "../../server/fizapilib.auto.ts";


// Augmentation of the generated beans with the methods added dynamically below
declare module "../../server/fizapilib.auto.ts" {
  interface CategoryBean {
    /** the name of a system category is not sent, it is translated client side */
    computedName(): string;
  }
}

CategoryBean.prototype.onDecode=function(this: CategoryBean): void {
  FwDatas.cache(this);
  if(!this.emoji){
    this.emoji = "🏷️"
  }
}
CategoryBean.prototype.computedName = function(this: CategoryBean): string {
  return this.name || i18n.get("mp.categories."+this.categorySystem);
}

Html.registerDom({
  async recipecatlist(): Promise<void> {
    let theModal = modal.openDomModal(MAIN_MODAL,{categories:await recipeCategoriesSyncCache.need()});
    theModal.addEventListener('change', Html.createDelegateListener(
      'input[name=emoji]',
      function(event, target: HTMLInputElement){
        const
          catNode = Html.getDomMetaIdNode(target),
          catFromCache = FwDatas.get(Html.getDomMetaId(catNode));

        catFromCache.emoji = target.value;
        ApiServer.mpcategoryput(catFromCache,function(cat: any){
          Html.replaceWithSingleDom(catNode,TPL_ITEM,cat);
        })
      }
    ));
    theModal.onClose=function(){
      recipeCategoriesSyncCache.refresh();
    }
  },
  recipecatclick:function(): void {
    const input = this.parentElement?.querySelector('input') as HTMLInputElement;
    if(input){
      input.focus();
      setTimeout(function(){input.select()},50);
    }
  },
  async recipecatdelete(): Promise<void> {
    const
      metaId = Html.getDomMetaId(this),
      cat = FwDatas.get(metaId);
    if(await modal.confirmDelete({title:"mp.categoriesaskdelete",message:"mp.categoriesaskdeletetext",yes:"actions.delete"})){
      ApiServer.mpcategorydelete([metaId],function(){
        const element = document.querySelector(`[data-fw-meta-id="${metaId}"]`) as HTMLElement;
        if(element){
          element.style.transition = 'opacity 300ms';
          element.style.opacity = '0';
          setTimeout(() => element.remove(), 300);
        }
        modal.toast({svg:Icons.recipe.ic_confirmation_toast_saved_recipe,iconStyle:'width:60px',text:i18n.getMustache("mp.categoriesdeleted",cat)})
      })
    };
  },
  recipecataddfield:function(): void {
    const hiddenTPL = this.previousElementSibling as HTMLElement;
    const container = hiddenTPL.previousElementSibling as HTMLElement;

    if(hiddenTPL && container){
      const cloned = hiddenTPL.cloneNode(true) as HTMLElement;
      container.appendChild(cloned);
      cloned.style.display = '';
      const input = cloned.querySelector('input') as HTMLInputElement;
      if(input) input.focus();
    }
  }
})

registerDragStart(".recipecategoryedit",async function(this: HTMLElement, ev: DragEvent, dropPromiseBuilder: any){
  const
    movingNode = this,
    potentialDrop = Array.from(document.querySelectorAll('.recipecategoryedit')),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = Html.getDomMetaIdNode(dropEvent.target);

  let nodeBefore: HTMLElement | null = null;
  const rect = dropNode.getBoundingClientRect();
  if(rect.top + rect.height/2 > dropEvent.clientY){
    nodeBefore = dropNode.previousElementSibling as HTMLElement;
    dropNode.parentNode!.insertBefore(movingNode, dropNode);
  }else{
    nodeBefore = dropNode;
    if(dropNode.nextSibling){
      dropNode.parentNode!.insertBefore(movingNode, dropNode.nextSibling);
    }else{
      dropNode.parentNode!.appendChild(movingNode);
    }
  }
  const nodeBeforeId = nodeBefore ? Html.getDomMetaId(nodeBefore) : null;
  //the JSON types of the generated beans are not exported
  ApiServer.mpcategoryput(new CategoryBean({metaId:Html.getDomMetaId(movingNode)} as any),nodeBeforeId||"$empty",function(cat: any){
    Html.replaceWithSingleDom(movingNode,TPL_ITEM,cat);
  })
  recipeCategoriesSyncCache.invalidate()
})


document.addEventListener('focus', Html.createDelegateListener(
  '.recipecategoryedit input',
  function(ev: FocusEvent, target: HTMLInputElement){
    const node = Html.getDomMetaIdNode(target);
    node.dataset.original = target.value;
    const clickBtn = node.querySelector('[data-fw-onclick="recipecatclick"]') as HTMLElement;
    const deleteBtn = node.querySelector('[data-fw-onclick="recipecatdelete"]') as HTMLElement;
    if(clickBtn) clickBtn.style.display = 'none';
    if(deleteBtn) deleteBtn.style.display = '';
  }
), true);

document.addEventListener('blur', Html.createDelegateListener(
  '.recipecategoryedit input',
  function(ev: FocusEvent, target: HTMLInputElement){
    ev.stopPropagation();
    const
      node = target.closest(".recipecategoryedit") as HTMLElement,
      metaId = Html.getDomMetaId(target),
      name = target.value.trim();

    if(target.readOnly) return;
    if(recipeCategoriesSyncCache.datas.filter((c: any)=>c.metaId!==metaId).filter((c: any)=>c.computedName()===name).length>0){
      target.classList.add('fw-form-invalid-control');
      return;
    }

    if(metaId){
      if(node.dataset.original !== name){
        let catFromCache = FwDatas.get(metaId)
        catFromCache.name = name;
        ApiServer.mpcategoryput(catFromCache,
          function(){target.classList.remove('fw-form-invalid-control')},
          function(){target.classList.add('fw-form-invalid-control')}
        )
      }
    }else if(name){
      ApiServer.mpcategoryput({name:name},function(cat: any){
        Html.replaceWithSingleDom(node,TPL_ITEM,cat)
      });
    }else{
      node.remove();
    }
    setTimeout(function(){
      const clickBtn = node.querySelector('[data-fw-onclick="recipecatclick"]') as HTMLElement;
      const deleteBtn = node.querySelector('[data-fw-onclick="recipecatdelete"]') as HTMLElement;
      if(clickBtn) clickBtn.style.display = '';
      if(deleteBtn) deleteBtn.style.display = 'none';
    },150)
  }
), true);

document.addEventListener('keypress', Html.createDelegateListener(
  '.recipecategoryedit input',
  function(ev: KeyboardEvent, target: HTMLInputElement){
    if(ev.keyCode===13 || ev.keyCode===10){
      ev.preventDefault();
      target.blur();
    }
  }
));
